"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayPeriodOffsetByDate = exports.getPayPeriodInfo = void 0;
const luxon_1 = require("luxon");
const getPayPeriodInfo = (payPeriodsToDisplay, payPeriodOffset) => {
    var _a;
    const isPayPeriodsValid = ((_a = payPeriodsToDisplay === null || payPeriodsToDisplay === void 0 ? void 0 : payPeriodsToDisplay.length) !== null && _a !== void 0 ? _a : 0) > 0;
    return {
        startDate: isPayPeriodsValid
            ? payPeriodsToDisplay[payPeriodOffset].startDate
            : undefined,
        endDate: isPayPeriodsValid
            ? payPeriodsToDisplay[payPeriodOffset].endDate
            : undefined,
        payDate: isPayPeriodsValid
            ? payPeriodsToDisplay[payPeriodOffset].payDate
            : undefined
    };
};
exports.getPayPeriodInfo = getPayPeriodInfo;
const getPayPeriodOffsetByDate = (payPeriodsToDisplay, date) => {
    if (!date || !(payPeriodsToDisplay === null || payPeriodsToDisplay === void 0 ? void 0 : payPeriodsToDisplay.length)) {
        return 0;
    }
    const index = payPeriodsToDisplay.findIndex((payPeriod) => {
        const startDate = luxon_1.DateTime.fromISO(payPeriod.startDate);
        const endDate = luxon_1.DateTime.fromISO(payPeriod.endDate);
        const selectedDate = luxon_1.DateTime.fromISO(date);
        return startDate <= selectedDate && endDate >= selectedDate;
    });
    return index >= 0 ? index : 0;
};
exports.getPayPeriodOffsetByDate = getPayPeriodOffsetByDate;
